<template>
  <transition name="slide-down">
		<div :id="id" class="menu-banner" :style="{ 'background-color': color }" v-if="!closed">
			<p>
				<b-icon :icon="icon" class="mr-3"></b-icon>
				{{ text }}
				<!-- Remove button deleted until patient app is fully migrated to this Vue client -->
				<!-- <b-icon class="ml-3" icon="x-circle" @click="onClose" style="cursor: pointer"></b-icon> -->
			</p>
		</div>
	</transition>
</template>

<script>
import { BLUE_COLOUR } from '@/constants/colours'

export default {
	name: 'BaseMenuBanner',
	data () {
		return {
			closed: true
		}
	},
	computed: {
		id () {
			return `menu-banner-${this._uid}`
		}
	},
	props: {
		text: {
			type: String,
			required: true
		},
		icon: {
			type: String,
			default: 'exclamation-circle'
		},
		color: {
			type: String,
			default: BLUE_COLOUR
		}
	},
	methods: {
		onClose () {
			this.closed = true

			this.$emit('close')
		}
	},
	created () {
		setTimeout(() => {
			this.closed = false
		}, 150)
	}
}
</script>

<style lang="scss">
	.menu-banner {
		display: flex;

		@include desktop {
			padding: .5rem 4rem;
			border-radius: $border-radius;
		}

		@include media(mobile, tablets) {
			padding: .5rem;
			width: 100%;
			z-index: 0;
		}

		color: white;

		p {
			margin: .75rem 1.5rem;

			@include desktop {
				margin-left: auto;
				margin-right: auto;
			}
			align-items: center;
			justify-content: center;
			font-size: .85rem;

			@include media(mobile, tablets){
				width: 100%;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/base/ui/BaseMenuBanner.vue